import { Component, Input } from '@angular/core';
import * as moment from 'moment';

/**
 *  Display date manipulation.
 *  Today dates displayed as 'Today 5:40 AM'
 *  Yesterday dates displayed as 'Yesterday 5:40 AM'
 *  All other dates formatted to AU format DD/MM/YY
 *
 *  usage:
 *    <moment-display [date]="msg.created_at"></moment-display>
 */
@Component({
  selector: 'moment-display',
  templateUrl: './moment-display.component.html',
  styleUrls: ['./moment-display.component.scss'],
})
export class MomentDisplayComponent {
  public dateFormat: any = {
    sameDay: 'LT',
    lastDay: '[Yesterday]',
    lastWeek: 'DD/MM/YYYY',
    sameElse: 'DD/MM/YYYY',
    nextDay: '[Tomorrow,] LT',
    nextWeek: 'dddd[,] LT',
  };

  @Input() date: string;

  @Input() fromNow = true;

  timeFromNow() {
    return moment(this.date).fromNow();
  }
}
